// Redimensiona una imagen a un lado máximo (manteniendo proporción) y la
// re-encodea como PNG, devolviendo un File liviano. Sirve para acotar en
// origen el peso del logo antes de subirlo. Browser-only (usa <canvas>).
export function downscaleImageFile(file, maxDimension) {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => {
            URL.revokeObjectURL(url);
            const largestSide = Math.max(image.width, image.height) || 1;
            const scale = Math.min(1, maxDimension / largestSide);
            const width = Math.max(1, Math.round(image.width * scale));
            const height = Math.max(1, Math.round(image.height * scale));

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            if (!ctx) {
                reject(new Error("Canvas no disponible"));
                return;
            }
            ctx.drawImage(image, 0, 0, width, height);
            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error("No se pudo procesar la imagen"));
                    return;
                }
                resolve(new File([blob], "logo.png", { type: "image/png" }));
            }, "image/png");
        };
        image.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("No se pudo cargar la imagen"));
        };
        image.src = url;
    });
}
